module.exports = __webpack_public_path__ + "img/president.88f293ca.jpg";